import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "./scoped-merchant-client";

export const useVideoContentFeatures = () => {
  const scope = useScopedMerchantClient();

  return useQuery({
    queryKey: ["video", scope.merchantId, scope.workspaceId, "content-features"],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].video.features.$get({
            param: scope.param,
          })
        : await client.merchant[":merchantId"].video.features.$get({
            param: scope.param,
          });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    enabled: !!scope.merchantId,
  });
};
